import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

/*Services */
import { ScreenService } from '@services/screen.service';
import { AuthService } from '@services/http/auth.service';
import { CachedDataService } from '@services/data/cached-data.service';

@Component({
  selector: 'app-restore',
  templateUrl: './restore.component.html',
  styleUrls: ['./restore.component.css']
})
export class RestoreComponent implements OnInit {
  showConfirmCode = false;
  restoreForm: FormGroup;
  confirmForm: FormGroup;
  ButtonText = 'Восстановить';
  errorMessage = '';
  successCode = false;

  errorConfirmPassword = {
    status: true,
    message: ''
  };
  errorPassword = null;
  passwordHasNumAndChar = true;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private screenService: ScreenService,
    private cachedDataService: CachedDataService) { }

  ngOnInit() {
    this.initForm();
    const tempUsername = this.cachedDataService.getTempUsername();
    if (tempUsername) {
      this.restoreForm.get('login').setValue(tempUsername);
    }

    this.screenService.isShowLoader = false;
  }

  initForm() {
    this.restoreForm = this.formBuilder.group({
      login: [null, [Validators.required]],
      newPassword: [null, [Validators.required, Validators.minLength(6)]],
      confirmPassword: [null, [Validators.required]],
      channel: ['sms']
    });
    this.confirmForm = this.formBuilder.group({
      code: ['', [Validators.required]],
    });
  }
  checkPassword() {
    const passLength = this.restoreForm.value.newPassword.length;
    const password = this.restoreForm.value.newPassword;
    if (passLength > 0) {
      if (this.restoreForm.get('newPassword').errors &&
        this.restoreForm.get('newPassword').errors.minlength &&
        this.restoreForm.get('newPassword').errors.minlength.actualLength < this.restoreForm.get('newPassword').errors.minlength.requiredLength) {
        this.errorPassword = `Пароль слишком короткий, ${passLength} символов`;
      } else {
        this.errorPassword = null;
      }

    } else {
      this.errorPassword = null;
    }

    if (/[a-zA-Z]/gi.test(password) && /[0-9]/gi.test(password)) {
      /*должен содержать хоть 1 символ и 1 цифру */
      this.passwordHasNumAndChar = true;
    } else {
      this.passwordHasNumAndChar = false;
    }

    if (passLength > 0 && this.restoreForm.value.confirmPassword.length > 0) {
      if (this.restoreForm.value.newPassword !== this.restoreForm.value.confirmPassword) {
        this.errorConfirmPassword.status = false;
        this.errorConfirmPassword.message = 'Подтверждение не совпадает с паролем';
      } else {
        this.errorConfirmPassword.status = true;
        this.errorConfirmPassword.message = 'Подтверждение совпадает с паролем';
      }
    } else {
      this.errorConfirmPassword.message = '';
    }
  }

  onChangeUsername(value) {
    this.restoreForm.controls['login'].setValue(value);
  }

  restore() {
    if (this.restoreForm.invalid) {
      const controls = this.restoreForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }
    if (!this.errorConfirmPassword.status) {
      return false;
    }

    if (!this.passwordHasNumAndChar) {
      return false;
    }

    this.ButtonText = 'Отправка..';
    this.authService.passwordRecovery(
      this.restoreForm.value.login.replace(/\D/g, ''),
      this.restoreForm.value.newPassword,
      this.restoreForm.value.channel
    )
      .then(() => {
        this.ButtonText = 'Подтвердить';
        this.errorMessage = '';
        this.showConfirmCode = true;
      })
      .catch((error: any) => {
        this.ButtonText = 'Восстановить';
        this.errorMessage = '';
        if (error.error.errorMessage.length) {
          this.errorMessage = error.error.errorMessage;
        } else {
          const errors = error.error.modelState;
          for (error in errors) {
            this.restoreForm.controls[errors[error].field].setErrors({ 'error': errors[error].errors });
          }
        }
      });
  }
  confirmPassword() {

    if (this.confirmForm.invalid) {
      const controls = this.restoreForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }
    this.ButtonText = 'Отправка..';
    this.authService.passwordConfirm(
      this.restoreForm.value.login.replace(/\D/g, ''),
      this.confirmForm.value.code
    )
      .then(() => {
        this.ButtonText = 'Подтвердить';
        this.successCode = true;
        this.cachedDataService.clearTempUsername();
        setTimeout(() => {
          this.router.navigate(['/signin']);
        }, 1500);
      })
      .catch((error: any) => {
        this.ButtonText = 'Подтвердить';
        if (error.error.errorMessage.length) {
          this.errorMessage = error.error.errorMessage;
        } else {
          const errors = error.error.modelState;
          for (error in errors) {
            this.restoreForm.controls[errors[error].field].setErrors({ 'error': errors[error].errors });
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/view/auth/restore/restore.component.ts